class BaseController {
  public hostUrl: string;
  public apiKey?: string;
  constructor(hostUrl: string, apiKey?: string) {
    this.hostUrl = hostUrl;
    this.apiKey = apiKey;
  }
}

export default BaseController;
